import { CardElement } from "@stripe/react-stripe-js";
import { callAPI } from "../../../services/api.service";
import { Toast } from "../Toast";
import { trackConversion } from "goaffpro-client";
import { StoryPurchaseTypeEnum } from "../../../interfaces/book.interface";
import { HTTPStatusEnum } from "../../../interfaces/log.interface";
import { CouponTypesEnum } from "../../../interfaces/coupon.interface";
import { UserModel } from '../../../interfaces/user.interface';

export const applyPromoCodeService = async (
  couponCode: string | null,
  user: UserModel | null,
  selectedPurchaseOption: string | null,
  setCouponClass: (value: string) => void,
  setCouponDescription: (value: string | null) => void,
  setPrice: (value: number | null) => void,
  setDiscount: (value: string | null) => void,
  setCouponLoader: (value: boolean) => void
) => {
  setCouponLoader(true);

  if (!couponCode) {
    Toast('Please Enter Coupon Code', true);
    setCouponLoader(false);
    return;
  }

  try {
    const response = await callAPI('user/coupon-validate', {
      couponCode,
      amount: user?.plan?.additionalAICredit?.price || 0,
      requestType: CouponTypesEnum.FOR_CREDITS_PURCHASE,
      email: user?.email,
    });

    if (response.status === HTTPStatusEnum.OK) {
      setCouponClass('text-storygreen');
      const discountedPrice = parseFloat(response?.data?.discount).toFixed(2);
      const price = parseFloat(response?.data?.price).toFixed(2);
      setCouponDescription(response?.data?.couponDescription);
      setPrice(+price);
      setDiscount(discountedPrice);
      Toast('Coupon Applied');
    } else {
      setDiscount(null);
      if (selectedPurchaseOption === StoryPurchaseTypeEnum.CREDITS) {
        setPrice(user?.plan?.additionalAICredit?.price || 0);
      } else if (selectedPurchaseOption === StoryPurchaseTypeEnum.STORY) {
        setPrice(user?.plan?.additionalAICredit?.storyCreationCost || 0);
      }
      setCouponClass('text-storyred');
      Toast('Invalid Coupon', true);
    }
  } catch (error) {
    Toast('Error applying promo code', true);
  } finally {
    setCouponLoader(false);
  }
};

export const handlePaymentService = async (
  stripe: any,
  elements: any,
  user: any,
  selectedPurchaseOption: string,
  freeOfCost: boolean,
  coupon: string | null,
  bookData: any,
  setShowThanksNote: (value: boolean) => void,
  setShowLowCreditModal: any,
  setPaymentLoader: (value: boolean) => void
) => {
  const creditsPrice =
    selectedPurchaseOption === StoryPurchaseTypeEnum.CREDITS
      ? user?.plan?.additionalAICredit?.price
      : user?.plan?.additionalAICredit?.storyCreationCost;

  if (freeOfCost) {
    const userData = {
      email: user?.email,
      requestType:
        selectedPurchaseOption === StoryPurchaseTypeEnum.CREDITS
          ? CouponTypesEnum.FOR_CREDITS_PURCHASE
          : CouponTypesEnum.FOR_STORY_PURCHASE,
      coupon,
      freeOfCost,
      creditsPrice,
      purchaseType: selectedPurchaseOption,
      bookId: bookData ? bookData?.bookId : null
    };
    const paymentResponse = await callAPI('user/purchase-credits', userData);
    if (paymentResponse?.status === HTTPStatusEnum.OK) {
      Toast('Image Credits Purchased Successfully');
      setShowThanksNote(true);
      if (setShowLowCreditModal) setShowLowCreditModal(false);
    } else Toast(paymentResponse?.message || 'Unexpected Error Occurred', true);
    setPaymentLoader(false);
  } else {
    if (!stripe || !elements) return;
    setPaymentLoader(true);

    const card = elements?.getElement(CardElement);
    const resultStripe = card && await stripe.createPaymentMethod({
      type: 'card',
      card: card,
      billing_details: {
        email: user?.email
      }
    });
    if (resultStripe?.error) {
      setPaymentLoader(false);
      Toast(resultStripe?.error?.message, true);
    } else {
      const userData = {
        email: user?.email,
        paymentMethod: resultStripe?.paymentMethod.id,
        requestType:
          selectedPurchaseOption === StoryPurchaseTypeEnum.CREDITS
            ? CouponTypesEnum.FOR_CREDITS_PURCHASE
            : CouponTypesEnum.FOR_STORY_PURCHASE,
        coupon,
        creditsPrice,
        purchaseType: selectedPurchaseOption,
        bookId: bookData ? bookData?.bookId : null
      };
      const paymentResponse = await callAPI('user/purchase-credits', userData);
      if (paymentResponse?.status === HTTPStatusEnum.OK) {
        Toast('Image Credits Purchased Successfully');

        //goaffpro track conversion
        trackConversion({
          number: paymentResponse?.paymentId, // human readable order number displayed to the admins
          total: creditsPrice,
          currency: 'USD'
        });

        setShowThanksNote(true);
        if (setShowLowCreditModal) setShowLowCreditModal(false);
      } else Toast(paymentResponse?.message || 'Unexpected Error Occurred', true);
      setPaymentLoader(false);
    }
  }
};
